
import './styles.css';
import InsaneTable from '../../component/insane-table';

function MaintenanceStandardGasLog(props) {
    const PARAM = props.location.state;
    // console.log(PARAM);
    const tableOption = {
        tableName: "Gas Logs",
        className: "",
        search: [],
        mapTable: [
            {
                displayName: "Gas log No",
                attName: "gaslogno",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "GasID",
                attName: "gasid",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "MT Result No",
                attName: "mtresultno",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Before value",
                attName: "beforevalue",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "After value",
                attName: "aftervalue",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Log time",
                attName: "logtime",
                type: "date",
                form: {
                    validate: true,
                    element: "input"
                }
            },
        ],
        api: {
            view: {
                enable: true,
                url: "/admin/mt/gaslog/get",
                dataReq: {
                    "index": 0,
                    "count": 10,
                    "gasid": PARAM.gasid
                }
            },
            insert: {
                enable: false,
                url: "/admin/mt/gaslog/update",
                dataReq: {}
            },
            update: {
                enable: false,
                url: "/admin/mt/gaslog/update",
                dataReq: {}
            },
            delete: {
                enable: false,
                url: "/admin/mt/gaslog/delete",
                dataReq: {}
            }
        },
        action: [
            // {
            //     name: "MT Result",
            //     mode: "page", /// page, modal, form
            //     option: {
            //         url: "/d-rec-admin/main/maintenance/result-mt/view"
            //     }
            // }
        ]
    }

    function twoDigit(n) {
        let number = parseInt(n);
        if (number <= 9) {
            return "0" + number
        } else {
            return "" + number
        }
    }

    function ConvertDate(dateString, type = "datetime") {
        // console.log(dateString);
        if (dateString) {
            let date = new Date(dateString);
            if (type === "datetime") {
                return date.getFullYear() + "-" + twoDigit((date.getMonth() + 1)) + "-" + twoDigit(date.getDate()) + " " + twoDigit(date.getHours()) + ":" + twoDigit(date.getMinutes()) + ":" + twoDigit(date.getSeconds())
            }
            if (type === "date") {
                return date.getFullYear() + "-" + twoDigit((date.getMonth() + 1)) + "-" + twoDigit(date.getDate())
            }
            if (type === "time") {
                return twoDigit(date.getHours()) + ":" + twoDigit(date.getMinutes()) + ":" + twoDigit(date.getSeconds())
            }
        } else {
            return "";
        }
    }

    return (
        <div className='content'>

            <div className='content-page'>
                <div className='head-content-page'>Standard : {PARAM.name} ({PARAM.gastype})</div>
                <div className='head-content-page-sub'>Start : {ConvertDate(PARAM.startdate, "date")} ---- Expire : {ConvertDate(PARAM.expiredate, "date")}</div>
                <div className='head-content-page-sub'>Unit : {PARAM.unit} </div>
                <InsaneTable option={tableOption}></InsaneTable>
            </div>

        </div >);
}

export default MaintenanceStandardGasLog;